//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from 'lodash-es'
import { mapActions, mapGetters } from 'vuex'
import DistributionListsHeader from '@/components/distribution-lists/DistributionListsHeader.vue'
import ReportStatusWatcher from '@/components/reports/ReportStatusWatcher'

export default {
  name: 'DistributionListLayout',
  components: {
    DistributionListsHeader,
    ReportStatusWatcher
  },
  data () {
    return {
      pageTheme: ''
    }
  },
  computed: {
    ...mapGetters({
      currentTheme: 'global/pageTheme',
      error: 'global/networkError',
      stack: 'global/networkErrorStack',
      isDesktop: 'breakpoints/desktop',
      isMobile: 'breakpoints/mobile',
      navOpen: 'global/navOpen',
      project: 'projects/getActiveProject'
    }),
    pageBreadcrumbs() {
      return this.pageMeta?.breadcrumbs || []
    },
    pageName() {
      return this.pageMeta?.name || 'Distribution Lists'
    },
    pageMeta() {
      const { id: distributionListId } = this.$route.params
      const pages = [
        {
          name: 'Add Distribution List',
          routeName: 'distribution-lists-add',
          breadcrumbs: [
            {
              text: 'Distribution Lists',
              href: '/distribution-lists/'
            },
            {
              text: 'Add Distribution List',
              href: '/distribution-lists/add',
              active: true
            }
          ]
        },
        {
          name: 'Edit Distribution List',
          routeName: 'distribution-lists-id-edit',
          breadcrumbs: [
            {
              text: 'Distribution Lists',
              href: '/distribution-lists/'
            },
            {
              text: 'Edit Distribution List',
              href: `/distribution-lists/${distributionListId}/edit`,
              active: true
            }
          ]
        },
        {
          name: 'Distribution List Detail',
          routeName: 'distribution-lists-id-details',
          breadcrumbs: [
            {
              text: 'Distribution Lists',
              href: '/distribution-lists/'
            },
            {
              text: 'Distribution List Detail',
              href: `/distribution-lists/${distributionListId}/details`,
              active: true
            }
          ]
        }
      ]
      const meta = pages.filter(p => p.routeName === this.$route.name)
      return meta[0]
    },
    showFullPageLayout() {
      return true// ['distribution-lists-detail'].includes(this.$route.name)
    },
    showError() {
      return this.error && this.error?.info?.status !== 401
    }
  },
  watch: {
    async $route(newVal) {
      if (newVal.params.projectid) {
        this.setPageTheme()
        if (!['projects', 'projects-add'].includes(this.$route.name)) {
          await this.setProjectId()
        }
      }
    }
  },
  async mounted () {
    this.setPageTheme()
    this.watchBreakpoints()
    if (!['projects', 'projects-add'].includes(this.$route.name)) {
      await this.setProjectId()
    }
  },
  methods: {
    ...mapActions({
      setActiveProjectId: 'projects/setActiveProjectId',
      setTheme: 'global/setPageTheme',
      startLoading: 'global/startLoading',
      stopLoading: 'global/stopLoading',
      toggleMenu: 'global/toggleMenu',
      watchBreakpoints: 'breakpoints/watch'
    }),
    async setProjectId() {
      if (isEmpty(this.project)) {
        this.startLoading()
        await this.setActiveProjectId(this.$route.params.projectid)
        this.stopLoading()
      }
    },
    setPageTheme () {
      const theme = this.$route.path.match(/dashboard|inbox|projects|reports|templates/gi)
      if (theme) {
        this.pageTheme = `theme-${theme[0]}`
        this.setTheme(theme[0])
      } else {
        this.pageTheme = 'theme-dashboard'
        this.setTheme('dashboard')
      }
    }
  }
}
